import httpClient from "../utilis/jwtRequest";

const USERS_URL = "/Customers";

function getCurrentUser() {
  return httpClient.get(`${USERS_URL}/current`)
}
function getUserById(id) {
  return httpClient.get(`${USERS_URL}/${id}/`);
}
function deleteUser(id) {
  return httpClient.delete(`${USERS_URL}/${id}/`);
}
function getAllUsers() {
  return httpClient.get(`${USERS_URL}/`);
}
function getUserChats(id) {
  return httpClient.get(`/Users/${id}/chats`);
}
function blockUser(id) {
  return httpClient.post(`/Users/${id}/block`);
}
function unblockUser(id) {
  return httpClient.post(`/Users/${id}/unblock`);
}
function updateUserNotes(id, note) {
  return httpClient.patch(`Users/${id}/`, { note: note })
}

export const usersService = {
  getCurrentUser,
  getUserById,
  deleteUser,
  getAllUsers,
  blockUser,
  unblockUser,
  getUserChats,
  updateUserNotes
};
